module.exports = __webpack_public_path__ + "static/formanalytics2-4a42e6fe6c27a1a7f094fb70f379d4ad.png";